import { Link } from '@tanstack/react-router'
import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'
import type { NavItem } from './nav-config'

interface SidebarNavProps {
  items: NavItem[]
  onNavigate?: () => void
}

const itemBase = 'flex items-center gap-3 rounded-control px-3 py-2 text-sm transition-colors'

export function SidebarNav({ items, onNavigate }: SidebarNavProps) {
  return (
    <nav className="flex flex-col gap-1">
      {items.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          onClick={onNavigate}
          className={cn(
            itemBase,
            'text-text-secondary hover:bg-bg-elevated hover:text-text-primary',
          )}
          activeProps={{ className: cn(itemBase, 'bg-bg-elevated text-text-primary') }}
        >
          <Icon name={item.icon} size={18} className="shrink-0" />
          {item.label}
        </Link>
      ))}
    </nav>
  )
}
